import styled from 'styled-components';

import { Row } from 'xpi-black-ui/Base/Grid';
import Text from 'xpi-black-ui/Base/Typography/Text/styles';

export default styled(Row)`
  cursor: pointer;
  width: fit-content;
  margin-bottom: 28px;

  ${Text} {
    margin-left: 8px;
  }
`;
